<template>
    <div class="header">
        <div class="logo">
            <router-link class="nav-rl" to="/backOffice"></router-link>
            <a href="#none"></a>
            <button class="btn-lnb">메뉴</button>
        </div>
        <div class="user-info">
            <span class="user-msg" style="color:#fff;">[{{ this.$store.state.loginInfo.loginDeptNm }}] <span
                    class="point-blue" style="color:#fff;">{{ this.$store.state.loginInfo.userName }}</span> <span>({{ this.$store.state.loginInfo.loginId }})</span></span>
            <router-link class="ico ico-home" to="/backOffice"></router-link>
            <router-link class="ico ico-top02" to="/backOffice/quickSetting"></router-link>
            <!-- <button class="ico ico-sms01" title="" @click="showSendSms" style="margin-left: 20px"></button> -->
            <button class="ico ico-pwdchg" title="" @click="showPasswordChange" style="margin-left: 20px"></button>
            <a href="#" class="ico ico-logout" title="" @click="logout"></a>
        </div>
    </div>
</template>

<script>
    import SendSms from '@/components/SendSms.vue';
    import PasswordChange from '@/components/PasswordChange.vue';

    export default {
        name: 'Navbar',
        components: {
            SendSms
        },
        props: {
            msg: String,
        },
        computed: {
            classObj() {
                return {
                    'navbar-item': true,
                    'is-hoverable': true,
                }
            },
        },

        data() {
            return {
                authority: ""
            };
        },

        mounted() {
            this.resizeMenu()
            this.authority = this.$store.state.loginInfo.authorities[0].roleCd;

            // Get all "navbar-burger" elements
            const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

            // Check if there are any navbar burgers
            if ($navbarBurgers.length > 0) {
                // Add a click event on each of them
                $navbarBurgers.forEach((el) => {
                    el.addEventListener('click', () => {
                        // Get the target from the "data-target" attribute
                        const {target} = el.dataset;
                        const $target = document.getElementById(target);

                        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                        el.classList.toggle('is-active');
                        $target.classList.toggle('is-active');
                    });
                });
            }
        },

        methods: {
            //로그아웃
            logout() {
                this.$swal({
                    type: 'info',
                    html: `그룹웨어 로그아웃이 선행되야 로그아웃이 됩니다.<br>아닌경우 다시 자동 로그인 처리됩니다.<br>로그아웃을 진행하시겠습니까?`,
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        this.$http
                                .get('/logout')
                                .then(() => {
                                    this.$store.commit('logout');
                                    this.$cookie.delete('loginInfo');
                                    this.$router.push({path: `/backOffice`});
                                })
                                .catch((e) => {
                                    console.error(e);
                                })
                    }
                })
            },
            resizeMenu() {
                $(".btn-lnb").click(function () {
                    if ($(".lnb").hasClass("minimized")) {
                        $(".lnb").removeClass("minimized");
                        $(".header > .logo").removeClass("mini");
                        $(".header .logo > a > img.logo-big").css("display", "inline-block");
                        $(".header .logo > a > img.logo-mini").css("display", "none");
                        if ($(".menu-depth01 > li").hasClass("hide")) {
                            $(".menu-depth01 > li.open").removeClass("hide");
                            //토글 상태 초기화
                            if ($(".menu-depth01 > li.open > .menu-depth02").css("display", "none")) {
                                $(".menu-depth01 > li.open > .menu-depth02").css("display", "block");
                            } else {
                                $(".menu-depth01 > li.open > .menu-depth02").css("display", "none");
                            }
                            $(".menu-depth01 > li.open > .menu-depth02").css("display", "none");
                            $(".menu-depth01 > li.open > .menu-depth02").toggle();
                        }
                        $(".header > .logo > .nav-rl").css("display", "block");
                    } else {
                        $(".lnb").addClass("minimized");
                        $(".header > .logo").addClass("mini");
                        $(".header .logo > a > img.logo-big").css("display", "none");
                        $(".header .logo > a > img.logo-mini").css("display", "inline-block");

                        if ($(".menu-depth01 > li").hasClass("open")) {
                            $(".menu-depth01 > li.open").addClass("hide");
                            //토글 상태 초기화
                            if ($(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "block")) {
                                $(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "none");
                            } else {
                                $(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "block")
                            }
                            $(".menu-depth01 > li.open.hide > .menu-depth02").css("display", "block");
                            $(".menu-depth01 > li.open.hide > .menu-depth02").toggle();
                        }
                        $(".header > .logo >.nav-rl").css("display", "none");
                    }
                });
            },
            showSendSms() {
                this.$modal.open({
                    component: SendSms,
                    props: {
                        loginId: this.$store.state.loginInfo.loginId,
                        loginNm: this.$store.state.loginInfo.userName
                    },
                    parent: this,
                    width: 1000
                })
            },
            showPasswordChange() {
              this.$modal.open({
                component: PasswordChange,
                props: {
                  loginId: this.$store.state.loginInfo.loginId,
                  loginNm: this.$store.state.loginInfo.userName
                },
                parent: this,
                width: 1000
              })
            },
        },


    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/common";

    .spacer {
        width: 80px;
    }

    .navbar {
        background-color: $green;
        font-weight: bold;
    }

    .header .user-info .ico-sms01{width:20px; height:15px; background:url("/../img/ico_sms01.png") no-repeat;}
    .header .user-info .ico-pwdchg{width:20px; height:15px; background:url("/../img/ico_pwdchg.png") no-repeat;}
</style>
